import { FilterType } from "@domain/enums/FilterType";
import { FilterMapper } from "@app/routing/mappers/FilterMapper";
import { disciplinesAll } from "@studyportals/static-domain-data/disciplines/disciplines";
import { subdisciplinesAll } from "@studyportals/static-domain-data/disciplines/subdisciplines";
import { disciplineGetVirtualPath } from "@studyportals/static-domain-data/disciplines/discipline-get-virtual-path";
import {disciplineGetSynonym} from "@studyportals/static-domain-data/disciplines/discipline-get-synonym";
import {IExtendedWithPortalTypeFilterValue} from "@app/routing/mappers/IExtendedWithPortalTypeFilterValue";
import { ISubDiscipline } from "@studyportals/static-domain-data/disciplines/i-sub-discipline";
import { IDiscipline } from "@studyportals/static-domain-data/disciplines/i-discipline";

interface IDisciplineWithIcon extends IExtendedWithPortalTypeFilterValue {
	icon?: string;
}

export class DisciplineFilterMapper extends FilterMapper {
	public filterType: FilterType = FilterType.DISCIPLINES;
	public isMultiSelect = false;
	private static instance: DisciplineFilterMapper;

	protected values: IExtendedWithPortalTypeFilterValue[] = [];
	private disciplines: IDisciplineWithIcon[] = [];
	private subdisciplines: IDisciplineWithIcon[] = [];

	public static getInstance(): DisciplineFilterMapper {
		if (!DisciplineFilterMapper.instance) {
			DisciplineFilterMapper.instance = new DisciplineFilterMapper();
		}
		return DisciplineFilterMapper.instance;
	}

	private constructor() {
		super();

		this.disciplines = this.buildDisciplineArray(disciplinesAll);
		this.subdisciplines = this.buildDisciplineArray(subdisciplinesAll);

		// eslint-disable-next-line @typescript-eslint/no-unused-vars
		this.values = [...this.disciplines, ...this.subdisciplines].map(({ icon, ...rest }) => rest);
	}

	private buildDisciplineArray(
		items: readonly (IDiscipline | ISubDiscipline)[]
	): IDisciplineWithIcon[] {
		const result: IDisciplineWithIcon[] = [];

		for (const item of items) {
			const virtualPath = disciplineGetVirtualPath(item.id.toString());
			if (!virtualPath) continue;

			const synonyms: string[] = [];
			const synonym = disciplineGetSynonym(item.id.toString());
			if (synonym) synonyms.push(synonym);

			result.push({
				id: item.id.toString(),
				virtualPath,
				name: item.name,
				synonyms,
				icon: item.icon
			});
		}

		return result;
	}

	public getDisciplines(): IDisciplineWithIcon[] {
		return this.disciplines;
	}

	public getSubdisciplines(): IDisciplineWithIcon[] {
		return this.subdisciplines;
	}

	public getDisciplineById(id: string): IDisciplineWithIcon | undefined {
		return this.disciplines.find((d) => d.id === id);
	}

	public getSubdisciplineById(id: string): IDisciplineWithIcon | undefined {
		return this.subdisciplines.find((d) => d.id === id);
	}
}
